/*
 * @Author: Gang Jiang
 * @Date: 2024-09-18 10:56:27
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-09-18 10:56:27
 */

<template>
  <div class="settings-page">
    <div class="bread-crumb">
      Settings
    </div>
    <h2>Settings</h2>

    <a-tabs v-model:activeKey="activeTab">
      <a-tab-pane
        key="featured"
        tab="FeaturedAdvertisers"
      >
        <FeaturedAdvertisers />
      </a-tab-pane>

      <a-tab-pane
        key="newsletter"
        tab="Newsletter"
      >
        <Newsletter />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import FeaturedAdvertisers from './settings/FeaturedAdvertisers.vue'
import Newsletter from './settings/Newsletter.vue'

const activeTab = ref('featured')
</script>
